import React, { useRef, useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  Button,
  OutlinedInput,
  FormHelperText,
} from "@mui/material";
import "./queryinterface.scss";
import SendIcon from "@mui/icons-material/Send";
import DayWiseList from "../../../components/List/DayWiseList";
import { useDispatch, useSelector } from "react-redux";
import {
  getHistoryDataForVisualization,
  getVisualizationProjects,
  submitForVisualizationQuery,
  submitForVisualizationResult,
  getVisualizationDetails,
  clearGetVisualizationDetailsResponse,
  submitForRegenerateVisualizationResult,
  clearVisualizationResultStatus,
  getHistoryDataForVisualizationRuntime,
  clearVisualizationDetails,
} from "../../../redux/investigation/actions";
import ProgressBar from "../../../components/ProgressBar";
import HistorySkeleton from "../../../components/Skeletons/HistorySkeleton";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import RefreshIcon from "@mui/icons-material/Refresh";
import CAMDrawer from "../../../components/LeftSideBar/CAMDrawer";
import InvestigatorContainer from "../../../components/contsiners/InvestigatorContainer";
import CAMHeader from "../../../components/Header/CAMHeader";

function Index() {
  const dispatch = useDispatch();
  const visualizationProjectsList = useSelector(
    (state) => state?.investigation?.visualizationProjectsList
  );
  const historyData = useSelector(
    (state) => state?.investigation?.visualizationDataHistory
  );
  const visualizationDetails = useSelector(
    (state) => state?.investigation?.visualizationDetails
  );
  const visualizationQueryStatus = useSelector(
    (state) => state?.investigation?.visualizationQueryStatus
  );
  const visualizationResultStatus = useSelector(
    (state) => state?.investigation?.visualizationResultStatus
  );
  const apiStatus = useSelector((state) => state?.investigation?.apiStatus);

  const user_input = useRef(null);
  const scrollRef = useRef(null);

  const [projectList, setProjectList] = useState([]);
  const [labelName, setLabelName] = useState("");
  const [mandateField, setMandateField] = useState(false);
  const [mandateLabel, setMandateLabel] = useState(false);
  const [openIframe, setOpenIframe] = useState(false);
  const [projectId, setProjectId] = useState(null);
  const [labelId, setLabelId] = useState();
  const [isSearchValue, setIsSearchValue] = useState(false);
  const [loader, setLoader] = useState(false);
  const [label, setLabel] = useState("Save");
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const [historyRegenerateError, setHistoryRegenerateError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");
  const [tableName, setTableName] = useState("");
  const [iframeLoaded, setIframeLoaded] = useState(false);

  useEffect(() => {
    setProjectList(visualizationProjectsList);
  }, [visualizationProjectsList]);

  useEffect(() => {
    dispatch(getHistoryDataForVisualization());
    dispatch(getVisualizationProjects());
    dispatch(clearVisualizationDetails());
    dispatch(clearGetVisualizationDetailsResponse());
    user_input.current.focus();
    setLabelName("");
    setLabel("Save");
    setIsDisabled(false);
    setOpenIframe(false);
    setIsSearchValue(false);
    user_input.current.value = "";
    setError(false);
    setHistoryRegenerateError(false);
    setSuccess(false);
    setMessage("");
    setIframeUrl("");
    setProjectId(null);
    setLabelId("");
    setIframeLoaded(false);
  }, []);

  useEffect(() => {
    if (visualizationQueryStatus?.next === true) {
      setIframeUrl(visualizationQueryStatus?.data?.data?.file_path);
      setProjectId(visualizationQueryStatus?.data?.data?.id);
      setLoader(false);
      setOpenIframe(true);
      dispatch(getHistoryDataForVisualizationRuntime());
      setIframeLoaded(false);
    }
    if (visualizationQueryStatus?.apiError === true) {
      setLoader(false);
      setError(true);
      setMessage(visualizationQueryStatus?.message || "Failed");
      dispatch(getHistoryDataForVisualizationRuntime());
      dispatch(clearGetVisualizationDetailsResponse());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizationQueryStatus]);

  useEffect(() => {
    if (
      visualizationDetails?.user_query &&
      visualizationDetails?.label &&
      visualizationDetails?.file_path
    ) {
      user_input.current.value = visualizationDetails?.user_query;
      setIsDisabled(true);
      setOpenIframe(true);
      setLabel("Regenerate");
      setLabelName(visualizationDetails?.label);
      setIframeUrl(visualizationDetails?.file_path);
      setHistoryRegenerateError(false);
      setIframeLoaded(false);
    }
    if (visualizationDetails?.error) {
      setHistoryRegenerateError(true);
      setMessage(visualizationDetails?.message || "Failed");
      dispatch(clearVisualizationDetails());
    }
    setLoader(false);
  }, [visualizationDetails]);

  useEffect(() => {
    if (visualizationResultStatus?.next === true) {
      onNewChatClick();
      setSuccess(true);
      setMessage(visualizationResultStatus?.message || "Failed");
      dispatch(getHistoryDataForVisualizationRuntime());
      dispatch(clearVisualizationResultStatus());
      setProjectId(null);
    }
    if (
      visualizationResultStatus?.next === false &&
      visualizationResultStatus?.apiError
    ) {
      setError(true);
      setMessage(visualizationResultStatus?.message);
      dispatch(clearVisualizationResultStatus());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizationResultStatus]);

  const onNewChatClick = () => {
    user_input.current.value = "";
    setOpenIframe(false);
    setIsDisabled(false);
    setProjectId(null);
    setLabel("Save");
    setLabelName("");
    setError(false);
    setMessage("");
    setSuccess(false);
    setHistoryRegenerateError(false);
    setIframeLoaded(false);
  };

  const clickListItem = (value) => {
    dispatch(getVisualizationDetails(value));
    setLabelId(value);
    setError(false);
    setHistoryRegenerateError(false);
    setMessage("");
    setSuccess(false);
    setOpenIframe(false);
    setIframeLoaded(false);
  };

  const sendQuerySubmit = () => {
    dispatch(clearGetVisualizationDetailsResponse());
    error && setError(false);

    let data = {
      project_id: projectId,
      user_input: user_input.current.value,
      table_name: tableName,
    };
    if (projectId === null) {
      setMandateField(true);
    } else {
      dispatch(submitForVisualizationQuery(data));
      setLoader(true);
    }
  };

  const handleLabelChange = (e) => {
    setLabelName(e.target.value);
  };

  const onProjectSelect = (value) => {
    setProjectId(value);
    const selectedProject = projectList.find((project) => project.id === value);
    setTableName(selectedProject?.table_name);
  };

  const saveVisualizationResult = (label) => {
    if (label === "Save") {
      let data = {
        table_name: tableName,
        id: projectId,
        label: labelName,
      };
      if (labelName === "") {
        setMandateLabel(true);
      } else {
        dispatch(submitForVisualizationResult(data));
      }
    } else {
      dispatch(submitForRegenerateVisualizationResult(labelId));
      setHistoryRegenerateError(false);
      setIframeLoaded(false);
    }
  };

  const handleChangeSerchText = () => {
    if (!isSearchValue) {
      setIsSearchValue(true);
    }
    if (user_input.current.value === "") {
      setIsSearchValue(false);
    }
    error && setError(false);
  };

  const handleIframeLoad = () => {
    setIframeLoaded(true);
  };

  return (
    <>
      <CAMHeader />
      <CAMDrawer />
      <InvestigatorContainer>
        <Grid container className="query-container">
          <Grid className="query-sidebar" item xs={6} md={3}>
            {apiStatus?.loader && Object.keys(historyData).length <= 0 ? (
              <HistorySkeleton />
            ) : (
              <DayWiseList
                error={mandateField}
                newChatClick={onNewChatClick}
                data={projectList}
                handleChange={onProjectSelect}
                clickListItem={(value) => clickListItem(value)}
                historyData={historyData}
                visualizationDetails={visualizationDetails}
                success={success}
                tableName={tableName}
              />
            )}
          </Grid>
          <Grid xs={6} item md={9}>
            <Grid container className="query-body">
              <Grid className="query-grid">
                <Typography className="header-text" variant="h4">
                  Visualization Interface
                  <span className="header-sub-span">(Beta)</span>
                </Typography>
              </Grid>

              <Box ref={scrollRef} className="query-card-container">
                {openIframe ? (
                  <Box className="card-container">
                    <iframe
                      className="iframe-style"
                      src={iframeUrl}
                      allowfullscreen
                      title="visualization_iframe"
                      scrolling="yes"
                      onLoad={handleIframeLoad}
                    ></iframe>
                  </Box>
                ) : (
                  <Box className="card-container2"></Box>
                )}

                {openIframe && !iframeLoaded && <ProgressBar />}

                {(loader || apiStatus?.loader) && <ProgressBar />}
                <Box className="query-footer">
                  {openIframe && (
                    <div className="input-label-container">
                      <div>
                        <OutlinedInput
                          className="label-field"
                          placeholder="Give a label to this query"
                          error={mandateLabel || historyRegenerateError}
                          value={labelName}
                          endAdornment={
                            <Button
                              variant="contained"
                              onClick={() => saveVisualizationResult(label)}
                              className="save-btn"
                            >
                              {label === "Regenerate" ? (
                                <>
                                  {label}
                                  <RefreshIcon />
                                </>
                              ) : (
                                label
                              )}
                            </Button>
                          }
                          onChange={handleLabelChange}
                          disabled={isDisabled}
                        />
                      </div>
                      <div>
                        {historyRegenerateError && (
                          <FormHelperText className="response-error">
                            {message}
                          </FormHelperText>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="message-style">
                    <OutlinedInput
                      error={error}
                      inputRef={user_input}
                      className="message-field"
                      fullWidth={true}
                      placeholder="Enter Your Visualization Query/requirement here"
                      multiline
                      maxRows={4}
                      onChange={() => handleChangeSerchText()}
                      disabled={isDisabled}
                      autoComplete="off"
                      endAdornment={
                        error ? (
                          <Button
                            variant="contained"
                            startIcon={<RefreshIcon />}
                            onClick={sendQuerySubmit}
                            className="regenerate-btn"
                          >
                            Regenerate
                          </Button>
                        ) : (
                          <IconButton
                            onClick={sendQuerySubmit}
                            disabled={
                              projectId === null ||
                              isSearchValue === false ||
                              isDisabled
                            }
                          >
                            <SendIcon />
                          </IconButton>
                        )
                      }
                    />
                    {error && (
                      <FormHelperText className="response-error">
                        {message}
                      </FormHelperText>
                    )}
                  </div>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {success && (
          <CustomizedSnackbars
            severity="success"
            state={success}
            text={message}
            handleClose={() => setSuccess(false)}
          />
        )}
      </InvestigatorContainer>

      {historyRegenerateError && (
        <CustomizedSnackbars
          severity="error"
          state={historyRegenerateError}
          text={message}
          handleClose={() => setHistoryRegenerateError(false)}
        />
      )}
    </>
  );
}

export default Index;
